import { Component } from '@angular/core';
import { InventoryService } from 'src/app/services/inventory.service';

@Component({
  selector: 'app-index-clients',
  template: `
    <div class="list-group">
      <div class="list-group-item list-group-item-action">
        <table>
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Descripción</th>
              <th>Sitio web</th>
              <th>Teléfono</th>
              <th>Correo electrónico</th>
              <th>Contacto</th>
              <th>Enlace</th>
              <th>Imagen</th>
              <th>Notas</th>
              <th>Es cliente</th>
              <th>Es proveedor</th>
              <th>Es fabricante</th>
              <th>Moneda</th>
              <th>Metadatos</th>
            </tr>
          </thead>
          <tbody>
            <tr app-tr-client
            *ngFor="let client of clients"
            
            ></tr>
          </tbody>
        </table>
      </div>
    </div>
  `,
  styles: ``
})
export class IndexClientsComponent {
  clients: any; // Client[] = [];

  constructor(
    private invService: InventoryService
  ) { }

  ngOnInit(): void {
  }

  loadClients() {
    // this.invService.getClients().subscribe((res: any) => {
      // this.clients = res.results;
    // });
  }

}
